import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";
const moduleName = "manure";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    preventList: {
      list: [],
      total: 0
    }
  },
  actions: {
    //查询-----获取所有数据
    async getPreventData({ commit }, payload) {
      let result = await api.get(
        `/api/FishFertilizer/GetDetali?${queryString.stringify(payload)}`
      );
      if (result.status === 200) {
        commit("setPreventList", result.data);
      }
      return result;
    },
    //添加
    async addPrevent(a, payload) {
      let result = await api.post("/api/FishFertilizer", payload);
      return result.data;
    },
    //删除数据
    async delPrevent(a, payload) {
      let result = await api.delete(`/api/FishFertilizer/` + payload);
      return result;
    },
    //删除子数据
    async delPreventDetail(a, payload) {
      let result = await api.delete(`/api/Precaution/Detail/` + payload);
      return result;
    },
    //编辑---获取单行数据
    async getEditPrevent(a, payload) {
      let result = await api.get(`/api/FishFertilizer/${payload}`);
      return result.data;
    },
    //修改
    async updatePrevent(a, payload) {
      let result = await api.put(`/api/FishFertilizer/${payload.orderId}`, payload);
      return result.data;
    },
    //修改养殖周期（采购单自动生成的单据仅允许修改周期）
    async updatePreventBatch(a, payload) {
      let result = await api.put(`/api/FishFertilizer/${payload.id}/Batch`, payload.data);
      return result.data;
    }
  },
  mutations: {
    setPreventList(state, payload) {
      state.preventList = payload;
    }
  },
  getters: {}
});

export default moduleName;
